import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'

export default {
    path: '/knowledge',
    name: 'Knowledge',
    meta: {
        title: '教研管理',
        keepAlive: false
    },
    component: Layout,
    redirect: '/knowledge/knowledgeList',
    children: [{
        path: 'knowledgeList',
        name: 'KnowledgeList',
        meta: {
            title: '知识点列表',
            keepAlive: false
        },
        component: resolve => require(['@/views/knowledge/knowledgeList/Index.vue'], resolve)
    }, {
        path: 'knowledgeList',
        name: 'KnowledgeTable',
        meta: {
            title: '知识点列表',
            keepAlive: false
        },
        component: Empty,
        children: [
            {
            path: 'knowledgeAdd',
            name: 'KnowledgeAdd',
            meta: {
                title: '编辑知识点',
                keepAlive: false
            },
            component: resolve => require(['@/views/knowledge/knowledgeList/KnowledgeAdd.vue'], resolve)

        },

            {
                path: 'knowledgDetail',
                name: 'knowledgDetail',
                meta: {
                    title: '预览知识点',
                    keepAlive: false
                },
                component: resolve => require(['@/views/knowledge/knowledgeList/KnowledgDetail.vue'], resolve),
                children: [{
                    path: '/knowledgeList/knowledgDetail/radioTestA1Detail',
                    name: 'RadioTestA1DetailKnow',
                    alias: '/radioTestA1DetailKnow',
                    meta: {
                        title: '预览试题',
                        keepAlive: false
                    },
                    component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA1Detail.vue'], resolve),

                }, {
                    path: '/knowledgeList/knowledgDetail/radioTestA3Detail',
                    name: 'RadioTestA3DetailKnow',
                    alias: '/radioTestA3DetailKnow',
                    meta: {
                        title: '预览试题',
                        keepAlive: false
                    },
                    component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA3Detail.vue'], resolve),

                }, {
                    path: '/knowledgeList/knowledgDetail/radioTestBDetail',
                    name: 'RadioTestBDetailKnow',
                    alias: '/radioTestBDetailKnow',
                    meta: {
                        title: '预览试题',
                        keepAlive: false
                    },
                    component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestBDetail.vue'], resolve),

                }]

            },
            {
                path: 'knowledgeAdd',
                meta: {
                    title: '编辑知识点',

                },
                component: Empty,
                children: [{
                    path: '/knowledge/knowledgeList/KnowledgeAdd/testQuestionCheck',
                    name: 'TestQuestionCheck',
                    meta: {
                        title: '选择试题',
                        keepAlive: false
                    },
                    component: resolve => require(['@/views/knowledge/knowledgeList/TestQuestionCheck.vue'], resolve)

                },
                    {
                        path: '/knowledge/knowledgeList/KnowledgeAdd/radioTestA1Detailcadd',
                        name: 'radioTestA1Detailcadd',
                        alias: '/radioA1',
                        meta: {
                            title: '预览试题',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA1Detail.vue'], resolve)

                    },
                    {
                        path: '/knowledge/knowledgeList/KnowledgeAdd/radioTestA3Detailccadd',
                        name: 'radioTestA3Detailccadd',
                        alias: '/radioA3',
                        meta: {
                            title: '预览试题',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA3Detail.vue'], resolve)

                    },
                    {
                        path: '/knowledge/knowledgeList/KnowledgeAdd/radioTestBDetailcadd',
                        name: 'radioTestBDetailcadd',
                        alias: '/radioB',
                        meta: {
                            title: '预览试题',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestBDetail.vue'], resolve)

                    },
                    {
                        path: '/knowledge/knowledgeList/KnowledgeAdd/testQuestionCheck',
                        name: 'testQuestionCheck',
                        meta: {
                            title: '选择试题',
                            keepAlive: false
                        },
                        component: Empty,
                        children: [{
                            path: '/knowledge/knowledgeList/KnowledgeAdd/testQuestionCheck/radioTestA1Detail',
                            name: 'radioTestA1Detailc',
                            meta: {
                                title: '预览试题',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA1Detail.vue'], resolve)

                        },
                            {
                                path: '/knowledge/knowledgeList/KnowledgeAdd/testQuestionCheck/radioTestA3Detail',
                                name: 'radioTestA3Detailc',
                                meta: {
                                    title: '预览试题',
                                    keepAlive: false
                                },
                                component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA3Detail.vue'], resolve)

                            },
                            {
                                path: '/knowledge/knowledgeList/KnowledgeAdd/testQuestionCheck/radioTestBDetail',
                                name: 'radioTestBDetailc',
                                meta: {
                                    title: '预览试题',
                                    keepAlive: false
                                },
                                component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestBDetail.vue'], resolve)

                            }]

                    }]

            }

        ],

    },

    ]
}
